import { render } from "./ModalTest.vue?vue&type=template&id=736ffe2c&ts=true"
import script from "./ModalTest.vue?vue&type=script&lang=ts"
export * from "./ModalTest.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__